export interface CompaniesClearAutocompleteActionType {
  type: '@companies/CLEAR_AUTOCOMPLETE';
  payload: {};
}

export const clearAutocomplete = () => ({
  type: '@companies/CLEAR_AUTOCOMPLETE',
  payload: {},
});
